import i18n, { InitOptions, Resource } from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "../locales/en.json";
import mrTranslation from "../locales/mr.json";

const resources: Resource = {
  en: {
    translation: enTranslation,
  },
  mr: {
    translation: mrTranslation,
  },
};

i18n.use(initReactI18next).init<InitOptions>({
  resources,
  lng: "mr",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
